import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.loader = true;
    },
    hideLoader: (state) => {
      state.loader = false;
    },
  },
});

export const { showLoader, hideLoader } = globalSlice.actions;
export default globalSlice.reducer;
